import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LetterTagsComponent } from './letter-tags.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@NgModule({
  declarations: [LetterTagsComponent],
  imports: [
    CommonModule,
    TooltipModule.forRoot(),
  ],
  exports: [LetterTagsComponent],
})
export class LetterTagsModule { }
